import PolicyLayout from '../../components/PolicyLayout';

export default function ShippingPage() {
  return (
    <PolicyLayout title="Shipping Policy" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Service Model</h2>
        <p className="text-slate-400">
          StatioPrint is an in-store printing service. We do not offer shipping or delivery of
          printed documents. All prints are collected directly from the print shop where you scanned
          the QR code.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. How It Works</h2>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Scan the QR code at your local print shop</li>
          <li>Upload your document and select print preferences</li>
          <li>Complete payment (online or Cash on Delivery)</li>
          <li>Your document is printed immediately at the shop</li>
          <li>Collect your prints from the shop counter</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. Collection Time</h2>
        <p className="text-slate-400 mb-4">
          Print jobs are processed immediately upon successful payment. Your documents will be ready
          for collection within:
        </p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>
            <strong>Standard documents:</strong> 1-2 minutes
          </li>
          <li>
            <strong>Large documents (50+ pages):</strong> 5-10 minutes
          </li>
          <li>
            <strong>Color prints:</strong> May take slightly longer
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. Uncollected Prints</h2>
        <p className="text-slate-400">
          Please collect your printed documents promptly. Uncollected prints will be held at the
          shop for up to 24 hours. After this period, the shop is not responsible for storing or
          maintaining uncollected prints. No refunds will be provided for uncollected documents.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">5. Shop Availability</h2>
        <p className="text-slate-400">
          Print services are available during the operating hours of each partner print shop. Please
          ensure you visit during their business hours to collect your prints.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">6. Questions?</h2>
        <p className="text-slate-400">
          For any questions about our service model, please contact us at{' '}
          <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
            info@statiomart.com
          </a>
        </p>
      </section>
    </PolicyLayout>
  );
}
